import React from 'react';

// Long figures step the type down so "131,020,000,000.00" still fits the row.
const sizeFor = (text) => (text.length > 15 ? 'xs' : text.length > 11 ? 'sm' : undefined);

/**
 * One currency: its code, its name, and an amount that can be typed into.
 * With `choices` (the foreign row), the code is a menu of the currencies that
 * can take its place; `onChoose` gets the code picked.
 */
export default function CurrencyRow({ code, name, value, active, onType, choices, onChoose, chooseLabel }) {
  return (
    <label className="cur-row" data-active={active || undefined}>
      <span className="cur-id">
        {choices ? (
          <span className="cur-code cur-menu">
            {code.toUpperCase()}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M7 10l5 5 5-5" />
            </svg>
            <select value={code} aria-label={chooseLabel} onChange={(e) => onChoose(e.target.value)}>
              {choices.map(([c, label]) => <option key={c} value={c}>{label}</option>)}
            </select>
          </span>
        ) : (
          <span className="cur-code">{code.toUpperCase()}</span>
        )}
        <span className="cur-name">{name}</span>
      </span>
      <input
        className="cur-input"
        data-size={sizeFor(value)}
        inputMode="decimal"
        autoComplete="off"
        aria-label={name}
        placeholder="0.00"
        value={value}
        // Selecting on focus means a first keystroke replaces the figure rather than editing inside it.
        onFocus={(e) => e.target.select()}
        onChange={(e) => onType(e.target.value)}
      />
    </label>
  );
}
